import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";

export default function LoginCallback() {
  const { isLoading, error, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated || !error) {
      navigate("/");
    }
  }, [isLoading, error, navigate, isAuthenticated]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return <div>Processing login...</div>;
}
